export default "/images/question_mark.png?db3336a955974a33feb01c52137eac9c";